import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-tippy';


export default class ModelReleasesStatusIcon extends React.Component {
    static propTypes = {
        tooltips: PropTypes.bool,
        photo: PropTypes.shape({
            modelReleases: PropTypes.shape({
                status: PropTypes.string.isRequired
            }).isRequired
        }),
        state: PropTypes.oneOf([
            'error', 'warning', 'success'
        ]).isRequired
    };
    static defaultProps = {
        tooltips: true,
        photo: null
    };


    render() {
        const { state, photo, tooltips } = this.props;

        let iconClass;
        let displayName;
        switch (state) {
            case 'error':
                iconClass = 'times';
                displayName = 'Rejected';
                break;
            case 'warning':
                iconClass = 'exclamation';
                displayName = photo && photo.modelReleases && photo.modelReleases.status === 'UPLOADED' ? 'Uploaded' : 'Missing';
                break;
            case 'success':
                iconClass = 'user';
                displayName = 'Sent to verification';
                break;
        }

        let icon = (
            <div className={`state-icon ${state}`}>
                <i className={`fa fa-${iconClass}`}></i>
            </div>
        );

        if (tooltips) {
            icon = (
                <Tooltip title={displayName}>
                    {icon}
                </Tooltip>
            );
        }

        return (
            <div className="component-model-releases-status-icon">{icon}</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/modelReleases/StatusIcon/index.js